import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const SidebarLeftOpenIcon = forwardRef<SVGSVGElement, IconProps>(
  (props, ref) => (
    <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
      <path d="M14.7 8.3a1 1 0 1 0-1.4 1.4l2.3 2.3-2.3 2.3a1 1 0 0 0 1.4 1.4l3-3c.4-.4.4-1 0-1.4l-3-3Z" />
      <path
        fillRule="evenodd"
        d="M5 22h14a3 3 0 0 0 3-3V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3ZM5 4a1 1 0 0 0-1 1v14c0 .6.4 1 1 1h3V4H5Zm5 0v16h9c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1h-9Z"
        clipRule="evenodd"
      />
    </Icon>
  )
);
export default SidebarLeftOpenIcon;
